<template>
  <div id="uploading-details">
    <!--POLICY-->
    <SelectPolicy
      v-if="loggedUser.organizationId === 0"
      :errors="errors"
      :session="session"
      :lightSessionRestart="lightSessionRestart"
      :type="type"
    />

    <v-tabs
      v-if="screenType === 'desktop' || uploadStep === 1"
      v-model="activeTab.tab"
      v-show="isShowUploadingDetails"
      class="px-2 pb-2"
      :class="[screenType !== 'desktop' && 'tabs-mobile']"
    >
      <div v-if="isShowTabs" class="mx-auto d-flex">
        <v-tab href="#regular">{{ $t('Registered') }}</v-tab>
        <v-tab href="#casual">{{ $t('Guest') }}</v-tab>
      </div>
      <v-tab-item value="regular" class="mt-2">
        <!--ROUTE-->
        <SelectRoute
          v-if="userActiveSourceRoutes.length"
          :session="session"
          :userActiveSourceRoutes="userActiveSourceRoutes"
          :errors="errors"
          :lightSessionRestart="lightSessionRestart"
          :type="type"
        />

        <!--REGISTERED RECIPIENTS-->
        <RegisteredRecipients
          v-if="isShowSelectRgisteredRecipients && activeTab.tab === 'regular'"
          :session="session"
          :errors="errors"
          :lightSessionRestart="lightSessionRestart"
          :type="type"
        />
      </v-tab-item>
      <v-tab-item value="casual" class="mt-2">
        <CasualRecipients v-if="loggedUser.isAllowCasuals" :session="session" />
      </v-tab-item>
    </v-tabs>
    <DynamicFields
      v-if="
        loggedUser.role !== 'Individual' &&
        loggedUser.role !== 'SuperAdmin' &&
        (activeTab.tab === 'regular' ? session.selectedRoute : true) &&
        session.interfaceDynamicFields
      "
      :session="session"
      :lightSessionRestart="lightSessionRestart"
      :screenType="screenType"
      :verifiedEmailsList="verifiedEmailsList"
      :pushToVerifiedEmailsList="pushToVerifiedEmailsList"
      class="mx-2"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

//Childrens
import SelectPolicy from './Childrens/SelectPolicy/SelectPolicy.vue'
import SelectRoute from './Childrens/SelectRoute/SelectRoute.vue'
import RegisteredRecipients from './Childrens/RegisteredRecipients/RegisteredRecipients.vue'
import Subject from './Childrens/Subject/Subject.vue'
import Message from './Childrens/Message/Message.vue'
import DynamicFields from '@/components/CommonComponents/DynamicFields/DynamicFields.vue'
import { mapMutations, mapActions } from 'vuex'
import Button from '@/components/BaseComponents/Button/Button.vue'
import CasualRecipients from './Childrens/CasualRecipients/CasualRecipients.vue'

export default {
  name: 'UploadingDetailsFields',
  props: {
    session: Object,
    errors: Object,
    userActiveSourceRoutes: Array,
    lightSessionRestart: Function,
    type: String,
    screenType: String,
    activeTab: Object,
    isShowUploadingDetails: Boolean,
    verifiedEmailsList: Array,
    pushToVerifiedEmailsList: Function,
  },

  components: {
    SelectPolicy,
    SelectRoute,
    RegisteredRecipients,
    Subject,
    Message,
    DynamicFields,
    Button,
    CasualRecipients,
  },

  computed: {
    ...mapGetters(['loggedUser', 'language', 'uploadStep']),
    isShowSelectRgisteredRecipients() {
      if (this.loggedUser.role === 'Casual') return true
      else if (this.loggedUser.organizationId === 0) return false
      else if (!this.session.selectedRoute?.routeId) return false
      return true
    },
    isShowTabs() {
      const isShowCasuals = this.loggedUser.isAllowCasuals
      const isShowRegistered = this.userActiveSourceRoutes.length > 0
      if (!isShowCasuals || !isShowRegistered) {
        const el = document.getElementsByClassName('v-slide-group')
        if (el && el.length && el[1]) el[1].style.display = 'none'
        return false
      } else {
        const el = document.getElementsByClassName('v-slide-group')
        if (el && el.length && el[1]) el[1].style.display = ''
      }

      return true
    },
  },

  methods: {
    ...mapActions(['GET_LOGGED_USER_ROUTES']),
    ...mapMutations(['SET_UPLOAD_STEP']),
    continueButtonClicked() {
      this.SET_UPLOAD_STEP(2)
      // this.$forceUpdate()
    },
  },
  watch: {
    session: {
      handler() {
        this.isShowErrorMessage = false
      },
      deep: true,
    },
    'session.selectedRoute': {
      handler: function (n) {
        if (this.session) {
          this.$set(this.session, 'interfaceDynamicFields', undefined)
        }

        if (n && this.session && this.activeTab.tab === 'regular') {
          const newFields = JSON.parse(JSON.stringify(n.interfaceDynamicFields))
          this.$set(this.session, 'interfaceDynamicFields', newFields)
        }
      },
    },
    activeTab: {
      handler(n) {
        if (n.tab === 'regular') {
          if (
            this.session.selectedRoute &&
            this.session.selectedRoute.routeId
          ) {
            const newFields = JSON.parse(
              JSON.stringify(this.session.selectedRoute.interfaceDynamicFields)
            )
            this.$set(this.session, 'interfaceDynamicFields', newFields)
          } else {
            this.$set(this.session, 'interfaceDynamicFields', undefined)
          }
          this.$set(this.session, 'selectedCasualUsers', [])
        } else if (n.tab === 'casual') {
          this.$set(this.session, 'selectedUsers', [])
          const newInterfaceDynamicFields = JSON.parse(
            JSON.stringify(this.loggedUser.interfaceDynamicFields)
          )
          this.$set(
            this.session,
            'interfaceDynamicFields',
            newInterfaceDynamicFields
          )
        }
      },
      deep: true,
    },
  },
 async mounted() {
    await this.GET_LOGGED_USER_ROUTES()
    if (
      this.loggedUser.role != 'Individual' &&
      !this.userActiveSourceRoutes.length
    ){
      this.activeTab.tab = 'casual'
    }
  },
}
</script>

<style>
#uploading-details .v-list--dense .v-list-item .v-list-item__content {
  padding: 0 !important;
}

#uploading-details .v-list--dense .v-list-item .v-list-item__title {
  line-height: 2rem !important;
}
</style>

<style scoped>
.btn1 button {
  background-color: red !important;
  color: white !important;
}
.btn2 button {
  background-color: green !important;
  color: white !important;
}
.tabs-mobile {
  max-height: 100% !important;
}
.v-tabs >>> .v-window {
  /* min-height: 300px !important; */
  overflow: visible;
  /* overflow-y: auto !important */
}
</style>
